var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGrayScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 50,
    viewBox: "0 0 130 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_95757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 48.7398L0.536412 47.6181C1.28967 48.2934 2.5822 48.7822 3.88613 48.7822C5.63803 48.7822 6.39129 48.1069 6.39129 47.231C6.39129 44.7786 0.24538 46.3269 0.24538 42.5947C0.24538 41.0464 1.46087 39.7241 4.12866 39.7241C5.31847 39.7241 6.54822 40.0406 7.38993 40.6141L6.91058 41.7612C6.02607 41.2018 5.02744 40.9447 4.12866 40.9447C2.40244 40.9447 1.6663 41.6623 1.6663 42.5353C1.6663 44.9877 7.81221 43.4536 7.81221 47.1435C7.81221 48.6776 6.56534 49.9999 3.88613 49.9999C2.33396 49.9999 0.813178 49.4828 0 48.7398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1397 47.375H15.7499L14.6314 49.8867H13.1392L17.7329 39.8398H19.1681L23.7761 49.8867H22.2553L21.1368 47.375H21.1397ZM20.6318 46.2251L18.4434 41.3005L16.2578 46.2251H20.6347H20.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4856 41.0886V44.5892H36.5729V45.8239H31.4856V49.8867H30.0361V39.8398H37.1978V41.0886H31.4856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.082 48.6379V49.8867H43.7178V39.8398H50.8794V41.0886H45.1672V44.1739H50.2546V45.3916H45.1672V48.6351H51.082V48.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2645 43.3433C74.2645 45.5216 72.6696 46.8439 70.0331 46.8439H67.5251V49.8867H66.0757V39.8398H70.0331C72.6696 39.8398 74.2645 41.1593 74.2645 43.3433ZM72.8151 43.3433C72.8151 41.908 71.845 41.0886 69.9903 41.0886H67.5251V45.5951H69.9903C71.845 45.5951 72.8151 44.7757 72.8151 43.3404V43.3433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.061 39.8398H82.5105V48.6379H88.003V49.8867H81.061V39.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.479 47.375H96.0892L94.9708 49.8867H93.4785L98.0723 39.8398H99.5074L104.115 49.8867H102.595L101.476 47.375H101.479ZM100.971 46.2251L98.7827 41.3005L96.5971 46.2251H100.974H100.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.457 41.0886H107.976V39.8398H116.367V41.0886H112.889V49.8867H111.454V41.0886H111.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 48.6379V49.8867H122.636V39.8398H129.797V41.0886H124.085V44.1739H129.173V45.3916H124.085V48.6351H130V48.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5245 10.9934H59.7212C59.7212 7.57192 62.5345 4.78613 65.9898 4.78613V6.57175C63.5274 6.57175 61.5245 8.55513 61.5245 10.9934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9902 26.5159L61.3765 21.9445L63.1626 20.1759L65.9902 22.9786L72.9065 16.1328L74.6926 17.8986L65.9902 26.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9928 0C63.0254 0 60.2378 1.14426 58.1407 3.22088C54.1147 7.20744 53.8351 13.5221 57.3018 17.8335L52.9106 22.1817L54.6968 23.9504L60.8199 17.8872L59.9268 17.0029C56.5828 13.6916 56.5828 8.30367 59.9268 4.99237C61.5474 3.38758 63.7017 2.50325 65.9928 2.50325C68.284 2.50325 70.4382 3.38758 72.0588 4.98955C74.1389 7.04922 74.9235 9.91128 74.4185 12.5784L76.4757 14.6155C77.8281 10.7589 76.9493 6.29768 73.845 3.22088C71.7478 1.14426 68.9602 0.00282534 65.9928 0.00282534V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_95757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrayScale);
export default __webpack_public_path__ + "static/media/logo_gray-scale.80a39319b57912bea5a22d19b6ea2eb2.svg";
export { ForwardRef as ReactComponent };